/* eslint-disable @typescript-eslint/no-explicit-any */
import { toRef, Ref } from '@nuxtjs/composition-api';

import IBiuroBaseInfo from '~/components/biura/types/IBiuroBaseInfo';

import { IClusterCalculatorDefinition } from '../../types/cluster/IClusterCalculatorDefinition';
import { IClusterDomInfo } from '../../types/cluster/IClusterDomInfo';
import IGoogleMapPosition from '../../types/IGoogleMapPosition';
import IMapBiuraServiceConfig from '../../types/IMapBiuraServiceConfig';
import IMarkerIcon from '../../types/marker/IMarkerIcon';
import moveMarkerPane from '../shared/moveMarkerPane';
import setZoom from '../shared/setZoom';
import buildCluster from './cluster/buildCluster';
import calculator from './cluster/calculator';
import addEventListenerToMapFullyLoaded from './event-listeners/addEventListenerToMapFullyLoaded';
import getMarkerPosition from './marker/getMarkerPosition';
import markerClicked from './marker/markerClicked';

const getMapFunctions = ({
  mapRef, config, markersInnerState, router, markerIcon,
}: IMapBiuraServiceConfig) => ({
  buildCluster: (): IClusterDomInfo => buildCluster(),
  getMarkerZIndex: (): number => 1000001,
  buildMarkerSvg: (): IMarkerIcon => markerIcon,
  getMarkerPosition(marker: IBiuroBaseInfo): IGoogleMapPosition {
    return getMarkerPosition(marker);
  },
  calculator(gmapMarkers: unknown[]): IClusterCalculatorDefinition {
    return calculator(gmapMarkers);
  },
  setZoom(value: number = 1) {
    return setZoom({ config, mapRef } as IMapBiuraServiceConfig, value);
  },
  markerClicked: (marker: IBiuroBaseInfo): void => {
    markerClicked({
      markerInfo: {
        marker,
        mapRef,
        activeMarker: toRef(markersInnerState, 'activeMarker') as Ref<IBiuroBaseInfo>,
      },
      router,
    });
  },
  mapIsFullyLoadedAndStreetViewIsUnvisible: (): boolean => config.isFullyLoaded && !config.streetViewIsVisible,

  init: async (serviceConfig: IMapBiuraServiceConfig): Promise<void> => {
    if (!mapRef?.value) return;

    const gmap = await mapRef.value.$mapPromise;

    addEventListenerToMapFullyLoaded({ serviceConfig, gmap });
    moveMarkerPane(gmap);
  },
});

export default getMapFunctions;
